module.exports = __webpack_public_path__ + "img/nav-var-acceptance.75c067e2.png";